import React, { useState } from 'react';
import Dialog from './Dialog';

export default function DeleteAccountDialog({ onDelete, onClose }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async event => {
    event.preventDefault();
    setBusy(true); setError('');
    try { await onDelete(password); onClose(); } catch (failure) {
      const authFailure = failure?.code?.startsWith('auth/');
      setError(authFailure ? 'Please check your password and try again.' : failure?.details?.reason === 'stripe-cancel-failed' ? 'Your web subscription could not be cancelled. Your account is still available. Please try again shortly.' : 'Your account could not be deleted. Please try again shortly.');
    } finally { setBusy(false); }
  };
  return (
    <Dialog onClose={busy ? undefined : onClose} labelledBy="delete-account-title" className="fixed inset-0 z-dialog flex items-center justify-center bg-black/85 p-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-white/15 bg-slate-900 p-6 text-white">
        <h2 id="delete-account-title" className="text-xl font-bold">Delete your account?</h2>
        <p className="mt-3 text-sm text-slate-300">This permanently removes your account and progress, and cancels any web subscription. Apple subscriptions must be cancelled separately through Apple, even if you delete your TapTap account. Enter your password to confirm.</p>
        <a href="https://apps.apple.com/account/subscriptions" target="_blank" rel="noopener noreferrer" className="mt-3 block text-sm text-indigo-200 underline">Manage Apple subscriptions</a>
        <label htmlFor="delete-password" className="mt-5 block text-sm">Password</label>
        <input id="delete-password" type="password" autoComplete="current-password" required value={password} onChange={event => setPassword(event.target.value)} disabled={busy} className="mt-2 min-h-11 w-full rounded-xl border border-white/20 bg-white/5 px-3" />
        {error && <p role="alert" className="mt-3 text-sm text-rose-200">{error}</p>}
        <button type="submit" disabled={busy} className="mt-5 min-h-11 w-full rounded-xl bg-red-500/25 px-4 font-bold text-red-100 disabled:opacity-50">{busy ? 'Deleting…' : 'Delete account permanently'}</button>
        <button type="button" onClick={onClose} disabled={busy} className="mt-2 min-h-11 w-full rounded-xl bg-white/10 px-4">Keep my account</button>
      </form>
    </Dialog>
  );
}
